
import { defineComponent, ref, computed, PropType } from "vue-demi";

interface IOption {
  label: string;
  value: string;
}

export default defineComponent({
  name: "Select",

  components: {},

  props: {
    options: {
      type: Array as PropType<IOption[]>,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    right: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["close", "action"],

  setup(props, { emit }) {
    const CLASS_ACTIVE = "active";

    const isOpen = ref(false);

    const selectedOption = ref(props.options[0]?.label || "");

    const selectClasses = computed(() => ({
      [CLASS_ACTIVE]: isOpen.value,
    }));

    const optionClasses = ({ label }: { label: string }) => {
      return {
        active: label === selectedOption.value,
      };
    };

    function toggleOpen() {
      if (props.disabled) return;

      isOpen.value = !isOpen.value;
    }

    function closeMenu() {
      isOpen.value = false;
    }

    function selectOption(option: { label: string; value: string; action: string }) {
      selectedOption.value = option.label;

      emit("action", { action: option.action, value: option.value });

      closeMenu();
    }

    return {
      isOpen,
      selectClasses,
      optionClasses,
      toggleOpen,
      closeMenu,
      selectOption,
      selectedOption,
    };
  },
});
